import { Component, EventEmitter, HostListener, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { Subscription } from 'rxjs';

import { ModalService } from "./modal.service";
import { WindowRef } from '@gene-ai/ui/services/window/window-ref.service';
import { DEFAULT_MODAL_CONFIG, MOBILE_DRAWER_RESOLUTION, ModalConfig, ModalState } from './modal';
import { CommonModule } from '@angular/common';
import { CloseIconComponent } from '../icon';

@Component({
    imports: [CommonModule, CloseIconComponent],
    selector: 'gene-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input() id!: string;
  @Input() headline?: string;
  @Input() subHeadline?: string;
  @Input() config: ModalConfig = DEFAULT_MODAL_CONFIG;

  @Output() close = new EventEmitter<void>();

  private modalService = inject(ModalService);
  private modalSubscription!: Subscription;
  private state: ModalState = 'closed';
  protected isMobile: boolean = WindowRef.innerWidth <= MOBILE_DRAWER_RESOLUTION;

  @HostListener('document:keydown.escape')
  onKeydownHandler() {
    if (this.isCloseable) {
      this.closeModal();
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = WindowRef.innerWidth <= MOBILE_DRAWER_RESOLUTION;
  }

  ngOnInit() {
    this.modalService.registerModal(this.id);
    this.modalSubscription = this.modalService.getModalState(this.id)
      .subscribe(state => this.state = state);
  }

  ngOnDestroy() {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }

  onOverlayClick() {
    if (this.isCloseable) {
      this.closeModal();
    }
  }

  closeModal() {
    this.close.emit();
    this.modalService.close(this.id);
  }

  get isCloseable() {
    return this.config.closeable;
  }

  get isOpen() {
    return this.state !== 'closed';
  }

  get isHidden() {
    return this.state === 'hidden';
  }

  get modalCssClass() {
    return {
      'hidden': this.isHidden,
    }
  }
}
